import { lazy } from '@loadable/component';

const CheckOutForm = lazy(() =>
  import(
    /* webpackChunkName: "checkoutform" */
    './checkout_form'
  )
);

export default CheckOutForm;
